export default "__VITE_ASSET__CETFldD2__"